/**
 * Représente un utilisateur
 */
import { APIResource, type Creatable, type Updatable } from '@/core/resources/APIResource'

export class User extends APIResource implements Updatable<User> {
  apiRoute: string = 'users'

  id: number = -999
  username: string = ''
  email: string = ''
  roles: Array<string> = []
  access_token: string = ''
  refresh_token: string = ''
  isLoggedIn: boolean = false

  getIdentifier(): any {
    return this.id
  }

  fromJson(json: UserResponse): this {
    this.id = json.id
    this.username = json.username
    this.email = json.email
    this.roles = json.roles
    return this
  }

  toJsonRequest(): UserUpdateRequest {
    return {
      username: this.username,
      email: this.email,
      roles: this.roles
    }
  }

  static fromLogin(json: LoginResponse): User {
    const user = new User()
    user.id = json.id
    user.username = json.username
    user.email = json.email
    user.roles = json.roles
    user.access_token = json.access
    user.refresh_token = json.refresh

    user.isLoggedIn = true
    return user
  }
}

export class UserCreateRequest implements Creatable<User> {
  username: string = ''
  email: string = ''
  password: string = ''
  password_confirm: string = ''
  roles: Array<string> = []

  constructor(user: User, password: string, password_confirm: string) {
    this.username = user.username
    this.email = user.email
    this.password = password
    this.password_confirm = password_confirm
    this.roles = user.roles
  }

  toJsonRequest() {
    return {
      username: this.username,
      email: this.email,
      password: this.password,
      password_confirm: this.password_confirm,
      roles: this.roles
    }
  }
}

export interface LoginResponse {
  id: number
  username: string
  email: string
  roles: Array<string>
  access: string
  refresh: string
}

export interface UserUpdateRequest {
  username: string
  email: string
  roles: Array<string>
}

export interface UserResponse {
  id: number
  username: string
  email: string
  token: string
  roles: Array<string>
}

export default User
